module.exports = __webpack_public_path__ + "static/img/teens_cybercrime.e013a18d.png";